(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iml-options-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
  const scope = document.querySelector('product-info');
  if (!scope || scope.dataset.imlAccessibleOptions) return;
  scope.dataset.imlAccessibleOptions = 'true';
  const strings = JSON.parse(document.getElementById('iml-options-strings').textContent);
  const printData = document.getElementById('iml-print-variants');
  if (printData) {
    const variants = JSON.parse(printData.textContent);
    const choices = new Map();
    let syncing = false;
    const selector = '.ymq-shopify-option-box select.ymq-shopify-option, .ymq-shopify-option-box input.ymq-shopify-option:checked';
    const remember = event => {
      if (!event.isTrusted || !event.target.matches(selector)) return;
      choices.set(event.target.closest('.ymq-shopify-option-box').id, event.target.value);
    };
    // Mobile select controls may commit input before the options app receives change.
    scope.addEventListener('input', remember, true);
    scope.addEventListener('change', remember, true);
    scope.addEventListener('change', event => {
      // Rechecking the app at purchase time must not start another theme render
      // that disables the button while its click is still being dispatched.
      if (syncing && event.target.closest('variant-selects')) event.stopImmediatePropagation();
    }, true);
    const syncPrintVariant = event => {
      const button = event.target.closest('button[name="add"], input[name="add"]');
      const form = event.type === 'submit' ? event.target : button?.form;
      if (!form || !form.action.includes('/cart/add')) return;
      const controls = [...scope.querySelectorAll(selector)];
      if (!controls.length) return; // Leave products using native Shopify options alone.
      controls.forEach(control => {
        const chosen = choices.get(control.closest('.ymq-shopify-option-box').id);
        if (chosen === undefined || control.value === chosen) return;
        if (control.tagName === 'SELECT') control.value = chosen;
        else {
          const replacement = [...control.closest('.ymq-shopify-option-box').querySelectorAll('input.ymq-shopify-option')].find(input => input.value === chosen);
          if (replacement) replacement.checked = true;
        }
      });
      const selected = [...scope.querySelectorAll(selector)];
      const values = selected.map(control => control.value);
      const variant = variants.find(item => item.options.length === values.length && item.options.every((value, index) => value === values[index]));
      const stop = () => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const control = selected[0];
        control.setCustomValidity('Please choose your print size and frame again before adding to cart.');
        control.reportValidity();
        control.addEventListener('change', () => control.setCustomValidity(''), { once: true });
      };
      if (!variant?.available) return stop();
      // Let the app update its own cached variant and line-item properties first.
      syncing = true;
      try {
        selected[selected.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        syncing = false;
      }
      const appId = scope.querySelector('#ymq-variant-id');
      if (!appId || String(appId.value) !== String(variant.id)) return stop();
      form.querySelectorAll('[name="id"]').forEach(input => { input.value = variant.id; });
      selected.forEach(control => control.setCustomValidity(''));
    };
    scope.addEventListener('click', syncPrintVariant, true);
    scope.addEventListener('submit', syncPrintVariant, true);
  }
  scope.addEventListener('input', event => {
    if (event.target.matches('#ymq-box .ymq-input-text')) {
      event.target.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Unidentified' }));
    }
  });
  let frame;
  const update = () => {
    frame = null;
    observer.disconnect();
    scope.querySelectorAll('#ymq-box .ymq-options-box').forEach(box => {
      const title = box.querySelector('.ymq_lable');
      if (!title) return;
      if (!title.id) title.id = 'iml-label-' + box.id;
      box.querySelectorAll('select,input:not([type=hidden]):not([type=radio]):not([type=search]),textarea').forEach(input => {
        input.setAttribute('aria-labelledby', title.id);
        if (box.dataset.validate?.includes('required')) input.setAttribute('aria-required', 'true');
      });
      box.querySelectorAll('select option').forEach(option => {
        if (!option.textContent.trim() && option.value) option.textContent = option.value;
        if (option.value) option.setAttribute('aria-label', option.value);
      });
      const error = box.querySelector('.ymq-error-box');
      if (error) {
        error.id = 'iml-error-' + box.id;
        error.setAttribute('aria-live', 'polite');
        box.querySelectorAll('select,input:not([type=hidden]):not([type=search]),textarea').forEach(input => {
          input.setAttribute('aria-describedby', error.id);
          input.setAttribute('aria-invalid', String(!!error.textContent.trim()));
        });
      }
    });
    if (scope.classList.contains('iml-portrait-page')) {
      const upload = scope.querySelector('#option-box-4');
      if (upload) {
        let status = upload.querySelector('.iml-upload-status');
        if (!status) {status = document.createElement('p');status.className = 'iml-upload-status';status.setAttribute('aria-live','polite');upload.append(status)}
        const previews = [...upload.querySelectorAll('.ymq_upload_img_view img')];
        const count = previews.length;
        const text = count ? (count === 1 ? strings.single : strings.plural).replace('__COUNT__',count) : '';
        if (status.textContent !== text) status.textContent = text;
        previews.forEach((img,index) => {if (!img.alt) img.alt = strings.reference.replace('__NUMBER__',index + 1)});
      }
      const style = scope.querySelector('#option-box-ymq-variant-0 input:checked')?.value;
      scope.querySelectorAll('media-gallery .product__media img').forEach(img => {
        if (!img.alt && style) img.alt = style + ' custom illustrated portrait style';
        const src = new URL(img.getAttribute('src'), location.href);
        if (src.pathname.includes('/cdn/shop/') && src.searchParams.get('width') === '600') {
          src.searchParams.set('width', '1200');
          img.src = src.href;
          img.srcset = [600, 900, 1200].map(width => {const url = new URL(src);url.searchParams.set('width', width);return url.href + ' ' + width + 'w'}).join(', ');
          img.sizes = '(min-width: 1440px) 680px, (min-width: 750px) 52vw, 100vw';
        }
      });
    }
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  };
  const observer = new MutationObserver(() => {if (!frame) frame = requestAnimationFrame(update)});
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["iml-portrait-assistance"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('iml-portrait-assistance')){
  class IMLPortraitAssistance extends HTMLElement{
    connectedCallback(){
      this.scope=document.querySelector('product-info');
      if(!this.scope)return;
      this.strings=JSON.parse(this.querySelector('[data-assistance-strings]').textContent);
      this.bar=this.querySelector('.iml-portrait-continue');
      this.mobile=window.matchMedia('(max-width:749px)');
      this.choices=new Map();
      this.onInteraction=event=>{
        if(!event.target.closest('#ymq-box,button[name=add]'))return;
        this.configureCheckout();
        if(event.target.closest('#option-box-1,#option-box-2,#option-box-3,#option-box-4,#option-box-ymq-variant-1'))this.detailsVisited=true;
        if(event.type==='focusin')this.lastControl=event.target;
        this.protectOrdering();
        this.schedule();
      };
      this.onChange=event=>{
        if(event.target.matches('#option-box-1 select,#option-box-2 select'))this.choices.set(event.target.id,event.target.value);
        this.schedule();
      };
      this.onContinue=()=>{
        const step=this.nextStep();
        if(!step)return;
        this.protectOrdering();
        if(step.kind==='details')this.detailsVisited=true;
        const target=step.target;
        if(!target.hasAttribute('tabindex')&&!target.matches('input,select,textarea,button'))target.tabIndex=-1;
        target.focus({preventScroll:true});
        const header=document.querySelector('.shopify-section-header-sticky');
        const offset=Math.min(header?.getBoundingClientRect().height||0,innerHeight*.3)+18;
        window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-offset),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        this.schedule();
      };
      this.onViewport=()=>this.scheduleBar();
      this.scope.addEventListener('pointerdown',this.onInteraction,true);
      this.scope.addEventListener('click',this.onInteraction,true);
      this.scope.addEventListener('focusin',this.onInteraction,true);
      this.scope.addEventListener('input',this.onInteraction,true);
      this.scope.addEventListener('change',this.onChange,true);
      this.bar.querySelector('button').addEventListener('click',this.onContinue);
      window.addEventListener('scroll',this.onViewport,{passive:true});
      window.addEventListener('resize',this.onViewport);
      window.visualViewport?.addEventListener('resize',this.onViewport);
      document.addEventListener('focusin',this.onViewport);
      document.addEventListener('focusout',this.onViewport);
      document.addEventListener('toggle',this.onViewport,true);
      document.addEventListener('transitionend',this.onViewport);
      this.observer=new MutationObserver(()=>this.schedule());
      this.popupObserver=new MutationObserver(()=>this.guardPopups());
      this.dialogObserver=new MutationObserver(()=>this.guardPopups());
      this.watchedDialogs=new WeakSet();
      this.update();
    }
    disconnectedCallback(){
      this.observer?.disconnect();this.popupObserver?.disconnect();this.dialogObserver?.disconnect();
      cancelAnimationFrame(this.frame);cancelAnimationFrame(this.barFrame);
      this.scope?.removeEventListener('pointerdown',this.onInteraction,true);
      this.scope?.removeEventListener('click',this.onInteraction,true);
      this.scope?.removeEventListener('focusin',this.onInteraction,true);
      this.scope?.removeEventListener('input',this.onInteraction,true);
      this.scope?.removeEventListener('change',this.onChange,true);
      window.removeEventListener('scroll',this.onViewport);window.removeEventListener('resize',this.onViewport);
      window.visualViewport?.removeEventListener('resize',this.onViewport);
      document.removeEventListener('focusin',this.onViewport);document.removeEventListener('focusout',this.onViewport);
      document.removeEventListener('toggle',this.onViewport,true);document.removeEventListener('transitionend',this.onViewport);
      document.documentElement.classList.remove('iml-ordering-in-progress');
    }
    schedule(){if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update()})}
    scheduleBar(){if(!this.barFrame)this.barFrame=requestAnimationFrame(()=>{this.barFrame=0;this.updateBar()})}
    configureCheckout(){
      if(!this.scope.querySelector('product-form[data-checkout-url]'))return;
      const extra=window.best_option?.ymq_option_branding?.extra;
      if(extra&&typeof extra==='object')extra['add-cart-url']='cart';
    }
    update(){
      this.observer.disconnect();
      this.configureCheckout();
      this.scope.querySelectorAll('#option-box-1 select,#option-box-2 select').forEach(select=>{
        let option=select.querySelector('[data-iml-photo-match]');
        if(!option){
          const original=select.querySelector('option[data-id]');
          if(!original)return;
          option=original.cloneNode(false);
          const key=original.dataset.id.split('_')[0]+'_iml_photo';
          option.id='ymq-attrib-'+key;option.dataset.id=key;option.dataset.price='0';option.dataset.imlPhotoMatch='true';
          option.className='ymq-attrib-item-'+key;
          option.value='Match my uploaded photos';option.textContent=this.strings.match;
          option.setAttribute('aria-label',this.strings.match);
          select.insertBefore(option,select.firstChild);
        }
        if(!select.dataset.imlPhotoInitialized){
          select.dataset.imlPhotoInitialized='true';
          const chosen=this.choices.get(select.id);
          if(chosen!==undefined&&[...select.options].some(item=>item.value===chosen))select.value=chosen;
          else if(!select.value)select.value=option.value;
          this.choices.set(select.id,select.value);
          select.dispatchEvent(new Event('change',{bubbles:true}));
        }
      });
      const hair=this.scope.querySelector('#option-box-2');
      if(hair&&!this.scope.querySelector('.iml-match-help'))hair.after(this.querySelector('[data-match-help]').content.cloneNode(true));
      const rush=this.scope.querySelector('#option-box-ymq-variant-1');
      if(rush&&!rush.querySelector('.iml-rush-help'))rush.append(this.querySelector('[data-rush-help]').content.cloneNode(true));
      this.observer.observe(this.scope,{childList:true,subtree:true});
      this.updateBar();
    }
    protectOrdering(){
      if(!this.ordering){
        this.ordering=true;
        document.documentElement.classList.add('iml-ordering-in-progress');
        this.popupObserver.observe(document.body,{childList:true,subtree:true});
      }
      this.guardPopups();
    }
    guardPopups(){
      if(!this.ordering||this.closingPopup)return;
      document.querySelectorAll('[role="dialog"]:has(form[data-testid^="klaviyo-form-"])').forEach(dialog=>{
        if(!this.watchedDialogs.has(dialog)){this.watchedDialogs.add(dialog);this.dialogObserver.observe(dialog,{attributes:true,attributeFilter:['style','class']})}
        if(dialog.style.display==='none'||dialog.hidden)return;
        const close=dialog.querySelector('button.klaviyo-close-form');
        if(!close)return;
        const restoreFocus=dialog.contains(document.activeElement);
        this.closingPopup=true;
        close.click();
        this.closingPopup=false;
        if(restoreFocus&&this.lastControl?.isConnected)this.lastControl.focus({preventScroll:true});
      });
      this.scheduleBar();
    }
    nextStep(){
      const style=this.scope.querySelector('#option-box-ymq-variant-0');
      if(!style)return null;
      if(!style.querySelector('input:checked'))return {kind:'details',target:style.querySelector('label[data-show]:not([hidden])')||style};
      const missing=[...this.scope.querySelectorAll('#option-box-1 select,#option-box-2 select')].find(select=>!select.value);
      if(missing)return {kind:'details',target:missing};
      const details=this.scope.querySelector('.iml-personalize-heading');
      if(!this.detailsVisited&&details)return {kind:'details',target:details};
      const upload=this.scope.querySelector('#option-box-4');
      const hasPhoto=upload&&!!upload.querySelector('.ymq_upload_file_item[data-name^="properties["]');
      if(upload&&!hasPhoto)return {kind:'photos',target:upload.querySelector('.ymq_upload_new')||upload};
      const submit=this.scope.querySelector('button[name=add]');
      return submit?{kind:'review',target:submit}:null;
    }
    updateBar(){
      const submit=this.scope.querySelector('button[name=add]');
      const step=this.nextStep();
      const active=document.activeElement;
      const editing=this.scope.contains(active)&&active.matches('input:not([type=radio]):not([type=hidden]),textarea,select');
      const keyboard=window.visualViewport&&window.visualViewport.height<innerHeight*.75;
      const modal=[...document.querySelectorAll('dialog[open],[role=dialog][aria-modal=true],cart-drawer.active')].some(element=>{
        if(element.closest('[hidden],[aria-hidden="true"],details:not([open])'))return false;
        const style=getComputedStyle(element);
        return element.getClientRects().length&&style.visibility!=='hidden'&&style.display!=='none'&&parseFloat(style.opacity)!==0;
      });
      const rect=submit?.getBoundingClientRect();
      const show=this.mobile.matches&&!!step&&!!rect&&rect.top>innerHeight-105&&!editing&&!keyboard&&!modal;
      this.bar.hidden=!show;
      if(!step)return;
      const label=step.kind==='review'?this.strings.review:this.strings.continue;
      const detail=step.kind==='review'?this.strings.reviewDetail:this.strings[step.kind];
      const labelNode=this.bar.querySelector('.iml-continue-label');
      const detailNode=this.bar.querySelector('.iml-continue-detail');
      if(labelNode.textContent!==label)labelNode.textContent=label;
      if(detailNode.textContent!==detail)detailNode.textContent=detail;
    }
  }
  customElements.define('iml-portrait-assistance',IMLPortraitAssistance);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["iml-proof-entry"] && !Shopify.designMode) return;
  try {
    (() => {
  const help = document.getElementById('iml-proof-help');
  if (!help) return;
  const params = new URLSearchParams(location.search);
  if (params.get('id')) return;
  const proof = document.getElementById('pf_content_div');
  if (proof) proof.hidden = true;
  help.hidden = false;
})();
  } catch(e) { console.error(e); }
})();

})();
